import {Suspense} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import ProgressBanner from '../../../common/components/progress-banner/ProgressBanner';
import MainMenu from '../components/main-menu/view/MainMenu';
import AlertsContainer from '../../../common/alerts/view/AlertsContainer';
import {observer} from "mobx-react";

function Loading() {
    return (
        <ProgressBanner>Loading, please wait...</ProgressBanner>
    );
}

import DefaultCharts from '../components/default-charts/DefaultCharts';

function App() {
    const {pathname} = useLocation();
    const showChartShortcuts = pathname.startsWith('/dashboard') || pathname.startsWith('/chart') || pathname === '/notification-settings';
    return (
        <>
            <AlertsContainer/>
            <div className="flex flex-col flex-1">
                <div className="w-full h-[68px] top-0 left-0 z-20">
                    <MainMenu/>
                </div>
                {showChartShortcuts && <DefaultCharts/>}
                <div className="flex flex-col min-w-0 flex-1">
                    <Suspense fallback={<Loading/>}>
                        <Outlet/>
                    </Suspense>
                </div>
            </div>
        </>
    );
}

export default observer(App);
